export default function Footer({children}){
    return (
        <footer>
            {children}
        </footer>
    )
}